import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => {

	return {
		parent: {
			background    : theme.other.colors.background.secondary,
			height        : "100dvh",
			display       : "flex",
			flexDirection : "column"
		},
		balanceChildText: {
			display    : "flex",
			alignItems : "baseline",
			gap        : "0.5rem"
		},
		balanceContainer: {
			marginBlockStart : "2.4rem",
			marginInline     : "1.6rem",
			padding          : "1.6rem",
			borderRadius     : "2rem",
			display          : "flex",
			border           : `1px solid ${ theme.other.paletteNew.darkModeDarkGrey20 } `,
			flexDirection    : "column",
			gap              : "1rem",
			background       : theme.other.colors.background.primary
		},
		balanceChild: {
			display    : "flex",
			alignItems : "center",
			gap        : "0.5rem"
		},
		linkIcon: {
			alignSelf: "baseline"
		},
		infoIcon: {
			height            : "1.6rem",
			width             : "1.6rem",
			marginInlineStart : "0.5rem"
		},
		addNowLink: {
			textDecoration: "underline"
		},
		diamondIcon: {
			height            : "1.6rem",
			width             : "1.6rem",
			marginInlineStart : "0.5rem"
		}
	};
} );
